import { fetchGroupMemberDetails } from "~/api/members";
import { Member } from "~/store";
import { GroupMember } from "~/types/group";

/**
 * Fetches and sets the currentGroupMember for the selected member and group
 * @param memberId The ID of the selected member
 * @param groupId The ID of the current group
 * @param setCurrentGroupMember Function to set the currentGroupMember in the global state
 * @returns The fetched GroupMember object or null if not found
 */
export const fetchAndSetGroupMember = async (
  memberId: number,
  groupId: number,
  setCurrentGroupMember: (groupMember: GroupMember | undefined) => void
): Promise<GroupMember | null> => {
  try {
    console.log(`Fetching group member details for member ${memberId} in group ${groupId}`);
    const groupMember = await fetchGroupMemberDetails(memberId, groupId);

    if (groupMember) {
      console.log("Setting currentGroupMember in global state:", groupMember);
      setCurrentGroupMember(groupMember);
    } else {
      console.warn(`No group member found for member ${memberId} in group ${groupId}`);
      // Clear the current group member if none found
      setCurrentGroupMember(undefined);
    }

    return groupMember;
  } catch (error) {
    console.error("Error fetching and setting group member:", error);
    // Clear the current group member on error
    setCurrentGroupMember(undefined);
    return null;
  }
};

/**
 * Updates the currentGroupMember when a member is selected
 * @param member The selected member
 * @param groupId The ID of the current group
 * @param setCurrentGroupMember Function to set the currentGroupMember in the global state
 */
export const updateCurrentGroupMember = async (
  member: Member | undefined,
  groupId: number | undefined,
  setCurrentGroupMember: (groupMember: GroupMember | undefined) => void
): Promise<void> => {
  if (!member || !groupId) {
    // Clear the current group member if no member or group is selected
    setCurrentGroupMember(undefined);
    return;
  }

  await fetchAndSetGroupMember(member.id, groupId, setCurrentGroupMember);
};
